const Footer = () => 
<footer>
    <div className="text-bg-vc-white">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-1 col-4 mx-auto pt-5 mt-3">
                    <img src="/img/logo.svg" className="w-100" alt="podcast coach sydney" />
                        </div>
                        <div className="col-lg-4 col-12 pt-5 mt-3">
                            <b>Head Office</b>
                    <address>
                        Level 3,<br />
                        66 Berry Street,<br />
                        North Sydney,<br />
                        NSW 2060, Australia<br />
                        Phone: <a href="tel:1300922122">1300 922 122</a><br />
                        Email: <span>studio@voicecoach.net</span>
                    </address>
                        </div>
                        <div className="col-lg-3 offset-lg-3 col-12 mt-3 px-2 pt-5">
                    <img src="/img/tvblogo.svg" className="w-100" alt="the voice business" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
<div className="col-12 text-center mt-5 bg-dark text-white py-3">&copy; 2023 VoiceCoach.Net is a brand of The Voice Business. All Rights Reserved. <br /><p className="text-center"><a href="/legal/privacy">Privacy Policy</a> | <a href="/legal/terms">Terms and Conditions</a></p></div>
    </div>
</footer>

export default Footer;